import React, { useEffect, useState } from 'react';
import { is } from '../../services/classify';
import clsx from 'clsx';
import { hashClass } from '../../helpers';
import { useTrilogyContext } from '../../context';
const ContextDropdown = React.createContext({
    displayDropdown: false,
});
export const useDrodownContext = () => {
    const context = React.useContext(ContextDropdown);
    if (context === undefined) {
        throw new Error('useDropdownContext must be used within a DropdownProvider');
    }
    return context;
};
/**
 * Dropdown Component
 * @param className {string} Additionnal CSS Classes
 * @param children {React.ReactNode} Dropdown Children
 * @param active {boolean} Activated Dropdown
 */
const Dropdown = ({ className, children, active, ...others }) => {
    const { styled } = useTrilogyContext();
    const [displayDropdown, setDisplayDropdown] = useState(active || false);
    const classes = hashClass(styled, clsx('dropdown', displayDropdown && is('active'), className));
    useEffect(() => {
        setDisplayDropdown(active || false);
    }, [active]);
    return (React.createElement(ContextDropdown.Provider, { value: { displayDropdown } },
        React.createElement("div", { className: hashClass(styled, clsx('field')) },
            React.createElement("div", { className: hashClass(styled, clsx('control')) },
                React.createElement("div", { onClick: () => {
                        setDisplayDropdown(!displayDropdown);
                    }, className: classes, ...others }, children)))));
};
export default Dropdown;
//# sourceMappingURL=Dropdown.js.map